<template>
    <div>
        <h1 class="fs-4 fw-bold text-dark mb-1 lh-sm">
            {{ authentication_user.active_store
                ? 'Costo por lista de precio'
                : 'Costo' }}
        </h1>
        <p class="text-muted small fw-medium">
            Actualiza el costo de reposición de los productos.
        </p>
        <TableReposicionConfig
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableReposicionConfig from './TableReposicionConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigReposicionOne from './configReposicionOne.vue';
import ConfigReposicionOptions from './configReposicionOptions.vue';

export default {
    name: 'config-reposicion',
    mixins: [configsRecModuleMixin],
    components: {
        TableReposicionConfig,
        ModalForm,
        ConfigReposicionOne,
        ConfigReposicionOptions,
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "reposicion",
                text: ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_replacement_cost/?${this.buildCommonParams()}&prop_extra_3=VIGENTE`;
        },
        viewModal(row, name, title, text) {
            this.componentName = name;
            this.propForm.size = false;
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component: this.componentName,
            };
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "reposicion",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
    }
};
</script>
